import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["personalIdField", "taxIdField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedType = this.element.querySelector('input[name="payout_account[account_type]"]:checked')?.value

    if (selectedType === "personal") {
      this.personalIdFieldTarget.style.display = "block"
      this.taxIdFieldTarget.style.display = "none"
    } else if (selectedType === "company") {
      this.personalIdFieldTarget.style.display = "none"
      this.taxIdFieldTarget.style.display = "block"
    }
  }
}
